import { FC, useEffect, useRef, useState } from "react";
import { KTSVG, toAbsoluteUrl } from "../../_metronic/helpers";
import { useChatStore } from "../../stores/ChatStore";
import useAccessToken from "../../hooks/AccessToken";
import { ChatListItem } from "./ChatListItem";
import { Message } from "../../interfaces/Chat/Message";
import { downloadMedia, generateQR } from "../../api/ChatHelper";
import addNotification from "react-push-notification";
import { useLocation, useNavigate } from "react-router-dom";
import useUser from "../../hooks/User";
import { MerchantLeads, RecentChatHistory, RecentChatHistoryPipeline } from "../../interfaces/Chat/RecentChatHistory";
import { useSettingsStore } from "../../stores/SettingsStore";
import Select, { components, DropdownIndicatorProps } from "react-select";
import { SelectOption } from "../../interfaces/SelectOption";
import axios from "axios";
import useSWR, { mutate } from "swr";
import { Progress } from "rsuite/esm/Progress/Progress";
import { base58Encode, rot8Encode } from "../../functions/encryption";
import moment from 'moment';
import { PersistedMessage } from "../../interfaces/Chat/PersistedMessage";
import { useCustomeStore } from "../../stores/CustomeStore";
import Swal from "sweetalert2";
import { ChatList } from "./ChatList";
import { useIntl } from "react-intl";
import { Modal } from "bootstrap";
import { AssignContactLabel } from "./Modal/AssignContactLabel";
import { LabelChatProps } from "../../interfaces/Chat/LabelChat";
import { icon } from "leaflet";
import { USER_MANAGER_HAPPY_PLAY } from "../../constant/General";
import { merge } from "chart.js/dist/helpers/helpers.core";
import { useTokenCustomCompany } from "../../stores/useTokenCustomCompany";
import useShowCompanyById from "../../hooks/useShowCompanyById";
import { focusChatInput, isMerchantOnly, sortChatRooms, sortListChat } from "../../functions/chat";
import { getChatRoomsData } from "../../api/ChatCRUD";
import { customNumberFormat } from "../../functions/general";
import { useUserStore } from "../../stores/UserStore";
import { ChatMerchant, ChatRoom, Condiments, ListChatRoom } from "../../interfaces/Chat/Chat";
import { useChatSearch } from "../../hooks/useChatSearch";
import { ChatListSearch } from "./ChatListSearch";

interface ChatSidebarProps {
    style: any
    handleIntSync: (isFirst: boolean) => void
}

const ChatSidebar = ({ style, handleIntSync }: ChatSidebarProps) => {
    const user = useUser()
    const intl = useIntl()
    const token = useAccessToken()
    const { companyId } = useCustomeStore()

    const navigate = useNavigate()
    const { pathname } = useLocation()
    const {
        socket, messages, connected,
        selectedChatPhone, phoneNumber,
        setMessageNotifications, setPhoneNumber, setShowChat,
        listChatRooms, setListChatMessages, setMessages, isFilterSidebar,
        setListChatRooms, setListFilterChat, searchSidebar, setIsFilterSidebar,
        persistedMessages, setLastSynced, lastSynced, setSearchSidebar,
        isSyncing, setIsOpenDetailContact, setMessage,
        setSelectedChatPhone, setPersistedMessagesCount,
        setIsWaitingForNetwork, isWaitingForNetwork, setMode, messagesIsSyncing,
        selectChatWindow, setSelectChatWindow, chatLabels, setMenuActive
    } = useChatStore()
    const { settings } = useSettingsStore()
    const { tokenCustomCompany } = useTokenCustomCompany()
    const { users, userLoading } = useUserStore()

    const [isLoading, setIsLoading] = useState(false)
    const [statusData, setStatusData] = useState<SelectOption[]>([])
    const [progressesData, setProgressesData] = useState<SelectOption[]>([])
    const [labelsData, setLabelsData] = useState<SelectOption[]>([])
    const [picData, setPicData] = useState<SelectOption[]>([])
    const [selectedFilterProgress, setSelectedFilterProgress] = useState<string[]>([]);
    const [selectedFilterLabel, setSelectedFilterLabel] = useState<string>("");
    const [selectedFilterStatus, setSelectedFilterStatus] = useState<string>("");
    const [selectedFilterPicMerchant, setSelectedFilterPicMerchant] = useState<string[]>([]);
    const [selectedFilterPicPipeline, setSelectedFilterPicPipeline] = useState<string[]>([]);
    const [selected, setSelected] = useState<{ [phone: string]: boolean }>({});
    const [showAssignContactLabelModal, setShowAssignContactLabelModal] = useState<boolean>(false);
    const [offset, setOffset] = useState(2500)
    const { company } = useShowCompanyById(user.data.company_id)
    const dropdownRef = useRef<HTMLDivElement | null>(null);

    const handleNotification = async (incomingMessage: ChatRoom) => {
        try {
            addNotification({
                title: incomingMessage.roomName ?? incomingMessage.roomPhone,
                message: incomingMessage.chat.message,
                native: true, // when using native, your OS will handle theming.
                // icon: response.data.data ? response.data.data : toAbsoluteUrl(`/media/logos/logo-wooblazz.png`),
                onClick: () => {
                    if (window.location.pathname !== '/chat') {
                        navigate('/chat');
                    }

                    const { messageNotifications, listChatMessages } = useChatStore.getState();
                    const key = `${incomingMessage.roomPhone}-${incomingMessage.as}`

                    setMessage('')
                    setIsOpenDetailContact(false)
                    if (listChatMessages[key] && listChatMessages[key].length > 0) {
                        setMessages(() => listChatMessages[key])
                    } else {
                        setMessages(() => [])
                    }

                    setListChatRooms((prevListChatRooms) => ({
                        ...prevListChatRooms,
                        [key]: {
                            ...prevListChatRooms[key],
                            selected: true
                        }
                    }));

                    const { [key]: removedItem, ...rest } = messageNotifications;
                    setShowChat(true)
                    setPhoneNumber(key)
                    setMode('normal')
                    setMessageNotifications(() => rest);
                    focusChatInput()
                }
            });
        } catch (error) {
            console.log(error)
        }
    }

    const handleFilterChange = (selectedOptions: SelectOption[] | SelectOption, type: string) => {
        if (type === "progress") {
            const selectedValues = (selectedOptions as SelectOption[]).map(option => option.value);
            setIsFilterSidebar(true);
            setSelectedFilterProgress(selectedValues);
        } else if (type === "picMerchant") {
            const selectedValues = (selectedOptions as SelectOption[]).map(option => option.value);
            setIsFilterSidebar(true);
            setSelectedFilterPicMerchant(selectedValues);
        } else if (type === "picPipeline") {
            const selectedValues = (selectedOptions as SelectOption[]).map(option => option.value);
            setIsFilterSidebar(true);
            setSelectedFilterPicPipeline(selectedValues);
        } else if (type === "labels") {
            setIsFilterSidebar(true);
            setSelectedFilterLabel((selectedOptions as SelectOption)?.value);
        } else if (type === "status") {
            setIsFilterSidebar(true);
            setSelectedFilterStatus((selectedOptions as SelectOption)?.value);
        } else if (type === "reset") {
            setIsFilterSidebar(false);
            setSelectedFilterProgress([]);
            setSelectedFilterPicMerchant([]);
            setSelectedFilterPicPipeline([]);
            setSelectedFilterLabel("");
            setSelectedFilterStatus("");
        }
    };

    const searchResults = useChatSearch(searchSidebar, selectedFilterProgress, selectedFilterLabel, selectedFilterStatus, selectedFilterPicMerchant, selectedFilterPicPipeline);
    useEffect(() => {
        setListFilterChat(searchResults)
    }, [searchResults])

    useEffect(() => {
        if (searchSidebar) {
            setMode("search")
        } else {
            setMode("normal")
        }
    }, [searchSidebar])

    // Function to debounce the setSearch
    const debounce = <F extends (...args: any[]) => void>(func: F, delay: number) => {
        let timeoutId: NodeJS.Timeout;
        return function (this: any, ...args: Parameters<F>) {
            if (timeoutId) {
                clearTimeout(timeoutId);
            }
            timeoutId = setTimeout(() => {
                func.apply(this, args);
            }, delay);
        };
    };

    // Debounced setSearch function with a delay of 500 milliseconds (0.5 second)
    const debouncedSetSearch = debounce(setSearchSidebar, 500);

    const DropdownIndicator = (
        props: DropdownIndicatorProps<SelectOption, true>
    ) => {
        return (
            <components.DropdownIndicator {...props}>
                <i className="fas fa-filter"></i>
            </components.DropdownIndicator>
        );
    };

    const fetcher = (url: string) => axios.get(url, {
        headers: {
            'X-Auth-token': token
        }
    }).then(res => res.data.data)

    const API_URL = process.env.REACT_APP_API_URL

    const { data: progresses = [], error: progressesError, isLoading: progressesLoading } = useSWR(`${API_URL}lead_progresses?onlyShowAllowedForCreateLeadLog=true`, fetcher)
    const { data: condiments, isValidating: isValidatingCondiments } = useSWR(Object.keys(listChatRooms).length > 0 ? `${API_URL}v2/chat/condiments` : null, fetcher)

    useEffect(() => {
        if (!progressesLoading) {
            const progressesData = progresses
                .filter((progress: Progress) => progress.name !== "Paid" && progress.name !== "Drop")
                .map((progress: Progress) => ({
                    value: progress.name,
                    label: progress.name
                }));

            // append the "New" option
            if (user.data.company_id !== companyId.elgisa) {
                progressesData.push({
                    value: 'NEW',
                    label: 'New'
                })
            }

            setProgressesData(progressesData)
        }
    }, [progresses])

    useEffect(() => {
        if (!userLoading) {
            const usersData = users.map((user: any) => ({
                value: user.name,
                label: user.name
            }));

            setPicData(usersData)
        }
    }, [users])

    useEffect(() => {
        if (!isValidatingCondiments && condiments && listChatRooms) {
            const { listChatRooms } = useChatStore.getState();
            const chatRoomTemp: ListChatRoom = Object.keys(listChatRooms).reduce((acc, key) => {
                const index = condiments.findIndex(
                    (condiment: Condiments) => condiment.phone === listChatRooms[key].roomPhone
                );

                acc[key] = index !== -1
                    ? {
                        ...listChatRooms[key],
                        merchants: condiments[index].merchants,
                        pipelines: condiments[index].leads,
                        labels: condiments[index].labels,
                    }
                    :
                    {
                        ...listChatRooms[key],
                        merchants: [],
                        pipelines: [],
                        labels: [],
                    }
                return acc;
            }, {} as ListChatRoom); // Pastikan tipe objek sesuai

            setListChatRooms(() => chatRoomTemp);
        }
    }, [condiments, isValidatingCondiments, lastSynced]);

    useEffect(() => {
        setStatusData([{ value: 'unread', label: 'Belum dibaca' }, { value: 'read', label: 'Dibaca' }])

        const updateNetworkStatus = () => {
            if (!navigator.onLine) {
                socket.disconnect()
                setIsWaitingForNetwork(true);
                setLastSynced(moment().format('YYYY-MM-DD HH:mm:ss').toString())
            } else {
                setIsWaitingForNetwork(false); // Reset waiting state once emitted
            }
        };

        // Event listeners for online/offline status
        window.addEventListener('load', updateNetworkStatus);
        window.addEventListener('online', updateNetworkStatus);
        window.addEventListener('offline', updateNetworkStatus);

        // Clean up the event listeners and interval when component unmounts
        return () => {
            window.removeEventListener('load', updateNetworkStatus);
            window.removeEventListener('online', updateNetworkStatus);
            window.removeEventListener('offline', updateNetworkStatus);
        };
    }, [lastSynced]);

    useEffect(() => {
        const labelsData = chatLabels.map((label: LabelChatProps) => ({
            value: label.id,
            label: label.name,
            color: label.color
        }));

        setLabelsData(labelsData);
    }, [chatLabels, messagesIsSyncing]);

    useEffect(() => {
        const result = selectChatWindow.reduce((acc, item) => {
            acc[item.phone] = true; // Set boolean value, bisa juga false sesuai kebutuhan
            return acc;
        }, {} as { [phone: string]: boolean });

        setSelected(result)
    }, [showAssignContactLabelModal])

    useEffect(() => {
        if (showAssignContactLabelModal) {
            const modalElement = document.getElementById(`assign-contact-label-modal`);

            if (modalElement) {
                const modalInstance = new Modal(modalElement);
                modalInstance.show();

                // This listener sets showChat to false when the modal is closed
                const handleModalHide = () => {
                    setShowAssignContactLabelModal(false);
                };

                // Attach the event listener
                modalElement.addEventListener('hidden.bs.modal', handleModalHide);

                // Clean up the listener when the component is unmounted or if showChat/chatHistory changes
                return () => {
                    modalElement.removeEventListener('hidden.bs.modal', handleModalHide);
                };
            }
        }
    }, [showAssignContactLabelModal, setShowAssignContactLabelModal]);

    useEffect(() => {
        socket.on("newChat", async (newChat) => {
            if(isMerchantOnly(settings, newChat, user) || !settings.chat_show_pic_only) {
                const { listChatRooms, listChatMessages, phoneNumber, messages } = useChatStore.getState();
                let tempChatRooms = { ...listChatRooms };
                let tempChatMessages = { ...listChatMessages };
                let key = `${newChat.roomPhone}-${newChat.as}`;
                const indexMessage = tempChatMessages[key]?.findIndex((chat) => chat.id === newChat.chats[0].id)
    
                setSelectedChatPhone((prev) => prev.map((item) => (
                    item.phone === newChat.as ? { ...item, newDateChat: newChat.chats[0].receivedAt } : item
                )));
    
                let tempChat = {
                    ...newChat.chats[0] || null,
                    phone: newChat.roomPhone,
                    as: newChat.as,
                    action: {
                        isEditing: false
                    }
                }
    
                if (indexMessage !== -1 && indexMessage !== undefined) {
                    setMessages((prevMessages) => {
                        if (!prevMessages[indexMessage]) return prevMessages; // Hindari error jika index tidak valid
    
                        if (phoneNumber === key) {
                            const updatedMessages = [...prevMessages];
                            updatedMessages[indexMessage] = tempChat
    
                            let sortedPart = updatedMessages.splice(indexMessage).sort((a, b) =>
                                new Date(a.receivedAt).getTime() - new Date(b.receivedAt).getTime()
                            );
                            updatedMessages.push(...sortedPart);
                            return updatedMessages;
                        }
    
                        return prevMessages;
                    });
    
                    tempChatRooms[key] = {
                        ...tempChatRooms[key],
                        chat: tempChat,
                    }
    
                    const worker = new Worker(new URL('../../app/pages/chat/SortChatRoomWorker.ts', import.meta.url));
                    worker.postMessage({ data: tempChatRooms });
                    worker.onmessage = (event) => {
                        const { data } = event.data;
                        setListChatRooms(() => data);
                        worker.terminate();
                    };
    
                    setListChatMessages((prevMessages) => {
                        const updatedMessages = { ...prevMessages };
                        updatedMessages[key][indexMessage] = tempChat
    
                        let sortedPart = updatedMessages[key].splice(indexMessage).sort((a, b) =>
                            new Date(a.receivedAt).getTime() - new Date(b.receivedAt).getTime()
                        );
                        updatedMessages[key].push(...sortedPart);
                        return updatedMessages;
                    })
                } else {
                    if (!tempChatRooms[key]) {
                        tempChatRooms[key] = {
                            as: newChat.as,
                            roomPhone: newChat.roomPhone,
                            roomName: newChat.roomName ? newChat.roomName : newChat.roomPhone,
                            isMerchantOnly: newChat.isMerchantOnly,
                            chat: tempChat,
                            labels: [],
                            merchants: [],
                            pipelines: [],
                            color: selectedChatPhone.find((item) => item.phone === newChat.as)?.color!,
                            connected: true,
                            selected: false
                        }
                    } else {
                        tempChatRooms[key] = {
                            ...tempChatRooms[key],
                            chat: tempChat
                        }
                    }
    
                    if (!tempChatMessages[key]) {
                        tempChatMessages[key] = [tempChat]
                    } else {
                        tempChatMessages[key] = [...tempChatMessages[key], tempChat]
                    }
    
                    // const worker = new Worker(new URL('../../app/pages/chat/SortChatRoomWorker.ts', import.meta.url));
                    // worker.postMessage({ data: tempChatRooms });
                    // worker.onmessage = (event) => {
                    //     const { data } = event.data;
                    //     setListChatRooms(() => data);
                    //     worker.terminate();
                    // };
    
                    let sortRooms = sortChatRooms(tempChatRooms)
                    setListChatRooms(() => sortRooms);
                    if (phoneNumber === key) {
                        setMessages(() => [...messages, tempChat])
                    }
    
                    setListChatMessages(() => tempChatMessages);
                }
    
                if (!newChat.chats[0].fromMe && phoneNumber !== key) {
                    let tempRoom: ChatRoom = {
                        as: newChat.as,
                        roomName: tempChatRooms[key].roomName ? tempChatRooms[key].roomName : tempChatRooms[key].roomPhone,
                        roomPhone: newChat.roomPhone,
                        labels: tempChatRooms[key].labels ? tempChatRooms[key].labels : [],
                        merchants: tempChatRooms[key].merchants ? tempChatRooms[key].merchants : [],
                        pipelines: tempChatRooms[key].pipelines ? tempChatRooms[key].pipelines : [],
                        isMerchantOnly: newChat.isMerchantOnly,
                        chat: tempChat,
                        color: selectedChatPhone.find((item) => item.phone === newChat.as)?.color!,
                        connected: true,
                        selected: false,
                    }

                    handleNotification(tempRoom)
                    setMessageNotifications((prevNotifications) => ({
                        ...prevNotifications,
                        [key]: {
                            ...prevNotifications[key],
                            latestMessage: newChat.chats[0].message,
                            unreadCount: (prevNotifications[key]?.unreadCount || 0) + 1,
                        },
                    }));
                }
            }
        })

        return () => {
            socket.off("newChat");
        }
    }, [socket])

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
                dropdownRef.current.querySelector(".dropdown-menu")?.classList.remove("show");
            }
        };

        document.addEventListener("click", handleClickOutside);
        return () => {
            document.removeEventListener("click", handleClickOutside);
        };
    }, []);

    const CustomOption = (props: any) => {
        return (
            <components.Option {...props}>
                <div style={{ display: 'flex', alignItems: 'center', whiteSpace: 'wrap' }}>
                    <svg viewBox="0 0 24 24" height="20" width="20" className="cursor-pointer me-2" preserveAspectRatio="xMidYMid meet" fill="none" style={{ color: props.data.color, width: '20px', flexShrink: 0, marginBottom: "auto" }}>
                        <path fill="currentColor" fillRule="evenodd" clipRule="evenodd" d="M15.393 5C16.314 5 17.167 5.447 17.685 6.182L21.812 12L21.346 12.657L17.686 17.816C17.166 18.553 16.314 19 15.393 19L5.81 18.992C4.262 18.992 3 17.738 3 16.19V7.81C3 6.261 4.262 5.008 5.809 5.008L15.393 5Z"></path>
                    </svg>
                    <span style={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>
                        {props.data.label}
                    </span>
                </div>
            </components.Option>
        );
    };

    const CustomSingleValue = (props: any) => {
        return (
            <components.SingleValue {...props}>
                <svg viewBox="0 0 24 24" height="20" width="20" className="cursor-pointer me-2" preserveAspectRatio="xMidYMid meet" fill="none" style={{ color: props.data.color }}>
                    <path fill="currentColor" fillRule="evenodd" clip-rule="evenodd" d="M15.393 5C16.314 5 17.167 5.447 17.685 6.182L21.812 12L21.346 12.657L17.686 17.816C17.166 18.553 16.314 19 15.393 19L5.81 18.992C4.262 18.992 3 17.738 3 16.19V7.81C3 6.261 4.262 5.008 5.809 5.008L15.393 5Z"></path>
                </svg>
                {props.data.label}
            </components.SingleValue>
        );
    };

    const isUseFilter = () => {
        if (selectedFilterLabel || selectedFilterStatus || selectedFilterProgress.length > 0 || selectedFilterPicMerchant.length > 0 || selectedFilterPicPipeline.length > 0) return true
        else return false
    }

    return (
        <div className='card card-flush w-100' style={{ maxHeight: "calc(100vh - 1rem)", height: "calc(100vh - 1rem)", ...style }}>
            <div className="d-flex align-items-center justify-content-between p-3 pb-0">
                <h1 className="mb-0 text-dark fw-bolder fs-1">Chat</h1>
                {/* <i className="p-3 fas fa-ellipsis-v fs-6 cursor-pointer"></i> */}
                {
                    !(settings.chat_show_pic_only && !user.data.is_superadmin) &&
                    <i className="fas fa-comment-medical fs-2 cursor-pointer" onClick={() => setMenuActive("initiate-chat")} style={{ paddingRight: "12px" }}></i>
                }
            </div>
            {
                connected &&
                <>
                    <div className="px-3">
                        {
                            (settings.chat_show_pic_only && !user.data.is_superadmin) &&
                            <span className="badge badge-primary">
                                Merchants only
                            </span>
                        }
                    </div>
                    {
                        selectChatWindow.length === 0 ?
                            <div className="card-header p-3" style={{ background: "white" }}>
                                <div className="w-100 d-flex gap-2">
                                    <form className='w-100 position-relative' autoComplete='off'>
                                        <span className="svg-icon svg-icon-1 position-absolute ms-6 mt-3">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                <rect opacity="0.5" x="17.0365" y="15.1223" width="8.15546" height="2" rx="1" transform="rotate(45 17.0365 15.1223)" fill="black" />
                                                <path d="M11 19C6.55556 19 3 15.4444 3 11C3 6.55556 6.55556 3 11 3C15.4444 3 19 6.55556 19 11C19 15.4444 15.4444 19 11 19ZM11 5C7.53333 5 5 7.53333 5 11C5 14.4667 7.53333 17 11 17C14.4667 17 17 14.4667 17 11C17 7.53333 14.4667 5 11 5Z" fill="black" />
                                            </svg>
                                        </span>
                                        <input
                                            type="search"
                                            className="form-control form-control-solid ps-15"
                                            placeholder={intl.formatMessage({ id: 'MASTERS.DATATABLE.SEARCH.PLACEHOLDER' })}
                                            onKeyDown={(e) => {
                                                if (e.key === 'Enter') e.preventDefault()
                                            }}
                                            style={{ borderRadius: "50px" }}
                                            onChange={(e) => debouncedSetSearch(e.target.value)}
                                        />
                                    </form>
                                    <div className='dropdown' ref={dropdownRef}>
                                        <button style={isUseFilter() ? { backgroundColor: "#f1faff" } : {}} type="button" className={`${!isUseFilter() && 'btn-white'} btn btn-icon dropdown-toggle`} data-bs-toggle="dropdown" aria-expanded="false">
                                            <KTSVG path='/media/icons/duotune/general/gen031.svg' className={`${isUseFilter() && 'svg-icon-primary'} svg-icon-2 m-0`} />
                                        </button>
                                        <div className='dropdown-menu p-0' style={{ maxWidth: '250px' }} onClick={(e) => e.stopPropagation()}>
                                            <div className="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-bold py-4 show" style={{ width: '250px' }}>
                                                <div className="menu-item px-3">
                                                    <div className="px-2 d-flex justify-content-between align-items-center">
                                                        <span className="fs-5">Filter</span>
                                                        {
                                                            isUseFilter() &&
                                                            <button className="btn btn-sm btn-light-primary" onClick={() => handleFilterChange({} as SelectOption, 'reset')}>Reset</button>
                                                        }
                                                    </div>
                                                </div>
                                                <div className="separator my-2"></div>
                                                <div className="menu-item px-3">
                                                    <Select
                                                        styles={{
                                                            control: (baseStyles, state) => ({
                                                                ...baseStyles,
                                                                borderColor: "#F5F8FA",
                                                                backgroundColor: "#F5F8FA",
                                                                borderRadius: "0.475rem",
                                                                width: "100%",
                                                                boxShadow: 'none',
                                                                '&:hover': {
                                                                    borderColor: "#F5F8FA",
                                                                    backgroundColor: "#F5F8FA",
                                                                },
                                                            }),
                                                            option: (baseStyles, { isSelected, isFocused }) => ({
                                                                ...baseStyles,
                                                                backgroundColor: isSelected ? '#2684FF' : isFocused ? '#dcf2ff' : 'none',
                                                                cursor: 'pointer',
                                                                zIndex: 99
                                                            }),
                                                            indicatorSeparator: (baseStyles, state) => ({
                                                                ...baseStyles,
                                                                display: 'none',
                                                            }),
                                                        }}
                                                        theme={(theme) => ({
                                                            ...theme,
                                                            colors: {
                                                                ...theme.colors,
                                                                primary: 'none',
                                                            },
                                                        })}
                                                        value={statusData.filter((opt) => opt.value === selectedFilterStatus)}
                                                        isClearable={true}
                                                        closeMenuOnSelect={true}
                                                        placeholder={`Status`}
                                                        onChange={(option) => handleFilterChange(option as SelectOption, "status")}
                                                        options={statusData}
                                                        className="my-2 h-40px"
                                                    />

                                                    <Select
                                                        styles={{
                                                            control: (baseStyles, state) => ({
                                                                ...baseStyles,
                                                                borderColor: "#F5F8FA",
                                                                backgroundColor: "#F5F8FA",
                                                                borderRadius: "0.475rem",
                                                                width: "100%",
                                                                boxShadow: 'none',
                                                                '&:hover': {
                                                                    borderColor: "#F5F8FA",
                                                                    backgroundColor: "#F5F8FA",
                                                                },
                                                            }),
                                                            option: (baseStyles, { isSelected, isFocused }) => ({
                                                                ...baseStyles,
                                                                backgroundColor: isSelected ? '#2684FF' : isFocused ? '#dcf2ff' : 'none',
                                                                cursor: 'pointer',
                                                                zIndex: 99
                                                            }),
                                                            indicatorSeparator: (baseStyles, state) => ({
                                                                ...baseStyles,
                                                                display: 'none',
                                                            }),
                                                            valueContainer: (baseStyles, state) => ({
                                                                ...baseStyles,
                                                                overflowY: 'auto',  // Mengaktifkan scroll horizontal
                                                                maxHeight: '80px', // Atur lebar maksimal agar tidak melebihi batas tertentu
                                                                scrollbarWidth: "thin", // Untuk Firefox
                                                                scrollbarColor: "#d1d1d1 transparent", // Untuk Firefox
                                                                "&::-webkit-scrollbar": {
                                                                    height: "4px", // Tinggi scrollbar
                                                                },
                                                                "&::-webkit-scrollbar-thumb": {
                                                                    backgroundColor: "#d1d1d1", // Warna scroll thumb
                                                                },
                                                            }),
                                                        }}
                                                        theme={(theme) => ({
                                                            ...theme,
                                                            colors: {
                                                                ...theme.colors,
                                                                primary: 'none',
                                                            },
                                                        })}
                                                        isMulti
                                                        value={progressesData.filter((opt) => selectedFilterProgress.includes(opt.value))}
                                                        closeMenuOnSelect={false}
                                                        placeholder={`Progress ${settings.pipeline_title}`}
                                                        onChange={(option) => handleFilterChange(option as SelectOption[], "progress")}
                                                        options={progressesData}
                                                        className="my-2"
                                                        isLoading={progressesLoading}
                                                    />

                                                    {
                                                        labelsData.length > 0 &&
                                                        <Select
                                                            styles={{
                                                                control: (baseStyles, state) => ({
                                                                    ...baseStyles,
                                                                    borderColor: "#F5F8FA",
                                                                    backgroundColor: "#F5F8FA",
                                                                    borderRadius: "0.475rem",
                                                                    width: "100%",
                                                                    boxShadow: 'none',
                                                                    '&:hover': {
                                                                        borderColor: "#F5F8FA",
                                                                        backgroundColor: "#F5F8FA",
                                                                    },
                                                                }),
                                                                option: (baseStyles, { isSelected, isFocused }) => ({
                                                                    ...baseStyles,
                                                                    backgroundColor: isSelected ? '#2684FF' : isFocused ? '#dcf2ff' : 'none',
                                                                    cursor: 'pointer',
                                                                    zIndex: 99
                                                                }),
                                                                indicatorSeparator: (baseStyles, state) => ({
                                                                    ...baseStyles,
                                                                    display: 'none',
                                                                }),
                                                            }}
                                                            theme={(theme) => ({
                                                                ...theme,
                                                                colors: {
                                                                    ...theme.colors,
                                                                    primary: 'none',
                                                                },
                                                            })}
                                                            isClearable={true}
                                                            closeMenuOnSelect={true}
                                                            value={labelsData.filter((opt) => opt.value === selectedFilterLabel)}
                                                            placeholder={intl.formatMessage({ id: "FORM.LABEL.LABELS" })}
                                                            onChange={(option) => handleFilterChange(option as SelectOption, "labels")}
                                                            options={labelsData}
                                                            components={{
                                                                Option: CustomOption,
                                                                SingleValue: CustomSingleValue,
                                                            }}
                                                            className="my-2 h-40px"
                                                        />
                                                    }

                                                    {
                                                        user.data.settings.chat_show_merchant_pic &&
                                                        <Select
                                                            styles={{
                                                                control: (baseStyles, state) => ({
                                                                    ...baseStyles,
                                                                    borderColor: "#F5F8FA",
                                                                    backgroundColor: "#F5F8FA",
                                                                    borderRadius: "0.475rem",
                                                                    width: "100%",
                                                                    boxShadow: 'none',
                                                                    '&:hover': {
                                                                        borderColor: "#F5F8FA",
                                                                        backgroundColor: "#F5F8FA",
                                                                    },
                                                                }),
                                                                option: (baseStyles, { isSelected, isFocused }) => ({
                                                                    ...baseStyles,
                                                                    backgroundColor: isSelected ? '#2684FF' : isFocused ? '#dcf2ff' : 'none',
                                                                    cursor: 'pointer',
                                                                    zIndex: 99
                                                                }),
                                                                indicatorSeparator: (baseStyles, state) => ({
                                                                    ...baseStyles,
                                                                    display: 'none',
                                                                }),
                                                                valueContainer: (baseStyles, state) => ({
                                                                    ...baseStyles,
                                                                    overflowY: 'auto',  // Mengaktifkan scroll horizontal
                                                                    maxHeight: '80px', // Atur lebar maksimal agar tidak melebihi batas tertentu
                                                                    scrollbarWidth: "thin", // Untuk Firefox
                                                                    scrollbarColor: "#d1d1d1 transparent", // Untuk Firefox
                                                                    "&::-webkit-scrollbar": {
                                                                        height: "4px", // Tinggi scrollbar
                                                                    },
                                                                    "&::-webkit-scrollbar-thumb": {
                                                                        backgroundColor: "#d1d1d1", // Warna scroll thumb
                                                                    },
                                                                }),
                                                            }}
                                                            theme={(theme) => ({
                                                                ...theme,
                                                                colors: {
                                                                    ...theme.colors,
                                                                    primary: 'none',
                                                                },
                                                            })}
                                                            isMulti
                                                            value={picData.filter((opt) => selectedFilterPicMerchant.includes(opt.value))}
                                                            closeMenuOnSelect={false}
                                                            placeholder={`PIC ${settings.merchant_title}`}
                                                            onChange={(option) => handleFilterChange(option as SelectOption[], "picMerchant")}
                                                            options={picData}
                                                            className="my-2"
                                                        />
                                                    }
                                                    {
                                                        user.data.settings.chat_show_lead_pic &&
                                                        <Select
                                                            styles={{
                                                                control: (baseStyles, state) => ({
                                                                    ...baseStyles,
                                                                    borderColor: "#F5F8FA",
                                                                    backgroundColor: "#F5F8FA",
                                                                    borderRadius: "0.475rem",
                                                                    width: "100%",
                                                                    boxShadow: 'none',
                                                                    '&:hover': {
                                                                        borderColor: "#F5F8FA",
                                                                        backgroundColor: "#F5F8FA",
                                                                    },
                                                                }),
                                                                option: (baseStyles, { isSelected, isFocused }) => ({
                                                                    ...baseStyles,
                                                                    backgroundColor: isSelected ? '#2684FF' : isFocused ? '#dcf2ff' : 'none',
                                                                    cursor: 'pointer',
                                                                    zIndex: 99
                                                                }),
                                                                indicatorSeparator: (baseStyles, state) => ({
                                                                    ...baseStyles,
                                                                    display: 'none',
                                                                }),
                                                                valueContainer: (baseStyles, state) => ({
                                                                    ...baseStyles,
                                                                    overflowY: 'auto',  // Mengaktifkan scroll horizontal
                                                                    maxHeight: '80px', // Atur lebar maksimal agar tidak melebihi batas tertentu
                                                                    scrollbarWidth: "thin", // Untuk Firefox
                                                                    scrollbarColor: "#d1d1d1 transparent", // Untuk Firefox
                                                                    "&::-webkit-scrollbar": {
                                                                        height: "4px", // Tinggi scrollbar
                                                                    },
                                                                    "&::-webkit-scrollbar-thumb": {
                                                                        backgroundColor: "#d1d1d1", // Warna scroll thumb
                                                                    },
                                                                }),
                                                            }}
                                                            theme={(theme) => ({
                                                                ...theme,
                                                                colors: {
                                                                    ...theme.colors,
                                                                    primary: 'none',
                                                                },
                                                            })}
                                                            isMulti
                                                            value={picData.filter((opt) => selectedFilterPicPipeline.includes(opt.value))}
                                                            closeMenuOnSelect={false}
                                                            placeholder={`PIC ${settings.pipeline_title}`}
                                                            onChange={(option) => handleFilterChange(option as SelectOption[], "picPipeline")}
                                                            options={picData}
                                                            className="my-2"
                                                        />
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            :
                            <div className="card-header p-3" style={{ background: "white" }}>
                                <div className="px-2 d-flex align-items-center justify-content-between w-100">
                                    <div className="d-flex align-items-center gap-5">
                                        <i className="p-3 cursor-pointer fas fa-times fs-3" onClick={() => setSelectChatWindow([])}></i>
                                        <div className="mb-0 text-dark fs-3">{selectChatWindow.length} {intl.formatMessage({ id: "FORM.LABEL.SELECTED_DATA" })}</div>
                                    </div>
                                    <svg onClick={() => setShowAssignContactLabelModal(true)} viewBox="0 0 24 24" height="24" width="24" className="cursor-pointer me-3" preserveAspectRatio="xMidYMid meet" fill="none" style={{ color: "#a1a5b7" }}>
                                        <path fill="currentColor" fillRule="evenodd" clip-rule="evenodd" d="M15.393 5C16.314 5 17.167 5.447 17.685 6.182L21.812 12L21.346 12.657L17.686 17.816C17.166 18.553 16.314 19 15.393 19L5.81 18.992C4.262 18.992 3 17.738 3 16.19V7.81C3 6.261 4.262 5.008 5.809 5.008L15.393 5Z"></path>
                                    </svg>
                                </div>
                            </div>
                    }
                    <div className="card-body px-3 pt-0" style={isLoading ? { height: '100vh' } : { height: '100%' }}>
                        {
                            isLoading &&
                            <div className="loading-overlay">
                                <div className="loader"></div>
                            </div>
                        }
                        {
                            isSyncing &&
                            <div id="sync-label" className="text-center">
                                <span className="badge badge-light-primary fs-7 fw-bold">
                                    Synchronizing
                                </span>
                            </div>
                        }
                        {
                            isWaitingForNetwork &&
                            <div id="network-status" className="alert alert-warning text-center mt-2">
                                Waiting for network...
                            </div>
                        }
                        {
                            searchSidebar || isFilterSidebar ?
                                <ChatListSearch />
                                :
                                <ChatList />
                        }
                    </div>
                </>
            }

            {
                showAssignContactLabelModal && <AssignContactLabel dataSelect={selected} setSelected={setSelected} />
            }
        </div>
    )
}

export { ChatSidebar }